module.exports = __webpack_public_path__ + "img/more_white.fb14012d.svg";